import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { CallState } from '@lcs/shared/api';
import { PasswordFormService } from 'src/app/common-components/password-form-control/password-form.service';
import { UserPasswordResetFormValue } from '../models/user-password-reset.form';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-user-password-reset-view',
    templateUrl: './user-password-reset-view.component.html',
    standalone: false
})
export class UserPasswordResetViewComponent {
   @Input() loading: CallState;

   @Output() passwordReset = new EventEmitter<UserPasswordResetFormValue>();

   form: UntypedFormGroup;

   constructor(private passwordFormService: PasswordFormService) {
      this.passwordFormService.initResetPasswordViewForm();
      this.form = this.passwordFormService.form;
   }

   onSubmit(): void {
      if (this.form.invalid) {
         this.passwordFormService.markControlsTouched();
      }
      if (this.form.valid) {
         this.passwordReset.emit(this.getFormValue());
      }
   }

   private getFormValue(): UserPasswordResetFormValue {
      return this.form.value;
   }
}
